<template>
  <AmexFlightDetails>
    <template v-slot:header>
      <AmexDetailsHeader :items="headerIcons" @change-view="onSelectDetailsView">
        <!-- <span class="link last">
          <button class="btn-clear summary" @click="backToSummaryView">Trip Summary</button>
        </span> -->
      </AmexDetailsHeader>
    </template>
  </AmexFlightDetails>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import {useSolutionViews} from '../../solution-views/solution-views';
import AmexFlightDetails from './solution-flight-details-content.vue';
import AmexDetailsHeader from '../details-header.vue';

Vue.use(VueCompositionAPI);

export default defineComponent({
  components: {
    AmexDetailsHeader,
    AmexFlightDetails,
  },
  setup(_, {root}) {
    const {backToSummaryView, headerIcons, onSelectDetailsView} = useSolutionViews(root);
    return {
      headerIcons,
      onSelectDetailsView,
      backToSummaryView,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '../btn-trip-summary.scss'
</style>
